<template>
<div>
    <b-card no-body border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
        <div slot="header">
            <strong>Wireless Interfaces:</strong> Updated {{relativeTime(device.status.wireless.aps.ts)}}
            <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'wireless_info', 5000)">
                <b-overlay :show="busy" rounded spinner-small spinner-variant="primary">
                    <i class="fa fa-refresh"></i>
                </b-overlay>
            </b-button>
        </div>
        <b-card no-body>
            <b-tabs small card justified>
                <b-tab v-for="(int, name, idx) in device.status.wireless.aps.data" :key="idx" :title='tabName(int.channel, int.ssid)' :active='activeTab(int.interface)' lazy>
                    <b-row no-gutters>
                        <b-col sm=4>
                            <b-card border-variant="light">
                                <statusdisplay :kkey="'Mode'" :vvalue="int.mode"></statusdisplay>
                                <statusdisplay :kkey="'SSID'" :vvalue="int.ssid"></statusdisplay>
                                <statusdisplay :kkey="'BSSID'" :vvalue="int.bssid"></statusdisplay>
                                <statusdisplay :kkey="'Signal'" :vvalue="int.signal"></statusdisplay>
                                <statusdisplay :kkey="'Bitrate'" :vvalue="int.bitrate"></statusdisplay>
                                <statusdisplay :kkey="'Channel'" :vvalue="int.channel"></statusdisplay>
                                <statusdisplay :kkey="'Tx Power'" :vvalue="int.txpower"></statusdisplay>
                                <statusdisplay :kkey="'Frequency'" :vvalue="int.frequency"></statusdisplay>
                                <statusdisplay :kkey="'Interface'" :vvalue="int.interface"></statusdisplay>
                            </b-card>
                        </b-col>
                        <b-col sm=8>
                            <b-card border-variant="light">
                                <!-- <plottraffic chartId="traffic" class="chart-wrapper" style="height:300px;margin-top:10px;" :interface=localInterface :device=int.interface></plottraffic> -->
                                <plotform :interface=localInterface :device=int.interface :deviceID="device.id"></plotform>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-tab>
                <!-- Render this if no tabs -->
                <template v-slot:empty>
                    <div class="text-center text-muted">
                        There are no open tabs
                    </div>
                </template>
            </b-tabs>
        </b-card>
    </b-card>
</div>
</template>

<script>
import moment from 'moment';
import StatusDisplay from './StatusDisplay';
import PlotTraffic from '../graphs/PlotTraffic'
import PlotForm from '../graphs/PlotForm'
export default {
    components: {
        'statusdisplay': StatusDisplay,
        'plottraffic': PlotTraffic,
        'plotform': PlotForm,
    },
    props: {
        device: {
            type: Object,
        },
    },

    data() {
        return {
            busy: false,
            timer: false,
            localInterface: 'lan',
            tabs: [],
            tabCounter: 0,
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    methods: {
        tabName(channel, ssid) {
            let Chan = (parseInt(channel) >= 1 && parseInt(channel) <= 14) ? "2.4 GHz" : "5 GHz";
            return ssid + ' (' + Chan + ')';
        },
        activeTab(val) {
            return (val === "wlan0") ? true : false;
        },
        linkClass(idx) {
            return (idx) ? ['bg-primary', 'text-light'] : ['bg-light', 'text-info'];
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        bool2text(value) {
            return (value) ? "Running" : "Not running";
        },
        fmtSeconds(secs) {
            return moment.utc(secs * 1000).format('HH:mm:ss') + " (h:m:s)"
        },
        cat(s1, s2, s3) {
            return s1 + s2 + s3;
        },
        enableTimer() {
            this.timer = true;
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
        },
        sendCmd(id, op, wait) {
            this.busy = true;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {
                if (response.data.success === true) {
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + ' seconds.';
                    this.makeToast('info', msg);
                    this.stReturn = setTimeout(() => {
                            this.$emit('childgetData_event');
                            this.busy = false;
                        },
                        wait);
                } else {
                    this.makeToast('danger', 'Unable to contact device.');
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
}
</script>
